export class RemoveUserPermissionsFailure {
    static readonly type = '[User] RemoveUserPermissionsFailure';
}
